import React from 'react'
import Error from '../components/Error'
import FooterErr from '../components/FooterErr'

function Err() {
  return (
    <>
       <Error />
       <FooterErr />
    </>
  )
}

export default Err